import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';
import {
    CarouselPlugin,
    TabsPlugin
} from 'bootstrap-vue';
import {
    homeMixin
} from './vue/mixins/home';
import TwentyTwenty from './vue/components/twenty-twenty/TwentyTwenty.vue';
import lazyload from './features/lazy-load';
import proportionalScroll from './features/proportional-scroll';
import MyNews from './vue/components/my-news/MyNews.vue';
import DolarSpotGraph from './vue/components/dolar-spot-graph/DolarSpotGraph.vue';
import MiniQuoteGraph from './vue/components/mini-quote-graph/MiniQuoteGraph.vue';
import QuoteGraph from './vue/components/quote-graph/QuoteGraph.vue';
import InsideHome from './vue/components/inside-home/InsideHome.vue';
import NewsStandRipe from './vue/components/news-stand-ripe/NewsStandRipe.vue';
import Trends from './vue/components/trends/Trends.vue';
import DayNews from './vue/components/day-news/DayNews.vue';
import LrPlusBenefits from './vue/components/lr-plus-benefits/LrPlusBenefits.vue';

lazyload();
proportionalScroll();

window.homeVue = initMain([tfmixin, homeMixin], {
    MyNews,
    DolarSpotGraph,
    MiniQuoteGraph,
    QuoteGraph,
    TextFill,
    TwentyTwenty,
    InsideHome,
    NewsStandRipe,
    Trends,
    DayNews,
    LrPlusBenefits
}, [
    CarouselPlugin,
    TabsPlugin
]);
header([{
    created() {
        this.userNews();
    }
}]);